import axiosInstance from "../libs/axiosInstance";

// get user quiz session
export const getUserQuizSession = async () => {
  const response = await axiosInstance.get('/quiz-session/');
  return response.data;
};

export const getAllUserQuizSessions = async () => {
  const response = await axiosInstance.get('/quiz-session/admin/sessions/');
  return response.data;
}

export const fetchQuizSessions = async ({ quizId, quizUrl }) => {
  let url = quizUrl ? quizUrl : `/quiz-session/lecturer/quiz/${quizId}/sessions/`

  // if it's a full URL (pagination), just fetch it
  const response = await axiosInstance.get(url)
  return response.data
}

export const fetchAllQuizSessions = async (quizId) => {
  const url = `/quiz-session/lecturer/quiz/${quizId}/sessions/all/`;
  const response = await axiosInstance.get(url);
  return response.data;
}

export const validateQuizSession = async (sessionId) => {
  const response = await axiosInstance.get(`/quiz-session/${sessionId}/validate/`);
  return response.data;
}

export const getProctoringReport = async (sessionId) => {
  const response = await axiosInstance.get(`/quiz-session/${sessionId}/proctoring/report/`);
  return response.data;
};

export const getEnvironmentUploadUrls = async (quizId, snapshotCount = 3) => {
  const response = await axiosInstance.post(`/quiz-session/quizzes/${quizId}/verify-environment/upload-urls/`, {
    snapshot_count: snapshotCount
  });
  return response.data;
};

export const uploadToR2 = async (url, file, contentType) => {
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file
  });
  
  if (!response.ok) {
    throw new Error(`Failed to upload to R2: ${response.statusText}`);
  }
  
  return true;
};

export const startEnvironmentVerification = async (quizId, videoKey, snapshotKeys) => {
  const response = await axiosInstance.post(`/quiz-session/quizzes/${quizId}/verify-environment/`, {
    video_key: videoKey,
    snapshot_keys: snapshotKeys
  });
  return response.data;
};

export const pollVerificationStatus = async (verificationId) => {
  const response = await axiosInstance.get(`/quiz-session/environment-verifications/${verificationId}/status/`);
  return response.data;
};

export const getVideoRetentionPeriod = async () => {
  const response = await axiosInstance.get('/quiz-session/admin/video-retention/');
  return response.data;
};

export const setVideoRetentionPeriod = async (days) => {
  const response = await axiosInstance.post('/quiz-session/admin/video-retention/', { days });
  return response.data;
};

export const ingestActivityLogs = async (sessionId, events) => {
  if (!sessionId || !events || events.length === 0) return null;
  const response = await axiosInstance.post(`/quiz-session/${sessionId}/activity-logs/`, {
    events,
  });
  return response.data;
};

export const fetchSessionActivityLogs = async (sessionId, { eventType, questionId, page = 1 } = {}) => {
  if (!sessionId) return { count: 0, results: [] };
  const params = {};
  if (eventType) params.event_type = eventType;
  if (questionId) params.question_id = questionId;
  if (page) params.page = page;

  const response = await axiosInstance.get(`/quiz-session/${sessionId}/activity-logs/`, { params });
  return response.data;
};
